export const DemoDataStageType = {
    IDLE: 'idle',
    ACTIVE: 'active',
    COMPLETED: 'completed',
    ERROR: 'error',
}

export const WelcomeScreenFrameId = 'welcomeScreenFrame'


// WEBPACK FOOTER //
// ./web/js/support/welcomeScreen/constants.js